import React from 'react';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';


import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { blue, red } from '@mui/material/colors';

import { createTheme } from '@mui/material/styles';

// Disable console logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.warn = () => { };
  console.error = () => { };
  console.debug = () => { };
  console.info = () => { };
}

const theme = createTheme({
  palette: {
    primary: {
      main: blue[900]
    },
    secondary: {
      main: red[600]
    }
  },
  typography: {
    fontSize: 11,
    fontFamily: [
      'Montserrat',
      'sans-serif'
    ].join(','),
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 700,
    },
    h2: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 700,
    },
    h3: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 700,
    },
    h4: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 700,
    },
    h5: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 600,
    },
    h6: {
      fontFamily: [
        'Barlow Condensed',
        'sans-serif'
      ].join(','),
      fontWeight: 600,
    },
  },
});


const root = require('react-dom/client').createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <App />
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
  //</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

/*
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <App />
          </LocalizationProvider>

        </ThemeProvider>
      </StyledEngineProvider>

    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
*/
